import { FormDescription } from "@/components/atom/title/form/FormDescription";
import { MantineSelectableTable } from "@/components/molecule/mantineSelectableTable/MantineSelectableTable";
import FormTemplate from "@/components/template/form/FormTemplate";
import { COMMON_TEXT } from "@/constants/text";
import { useItemDrawingInfoFormFetch } from "@/fetch/form/useItemDrawingInfoFormFetch";
import { usePaginationStore } from "@/store/pagenation.store";
import { ActionIcon, Flex, Pagination } from "@mantine/core";
import { CommonStandardAttachmentsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { IconDownload } from "@tabler/icons-react";
import dayjs from "dayjs";
import { MRT_ColumnDef } from "mantine-react-table";
import { useEffect } from "react";

const ItemDrawingInfo = Object.assign(
  {},
  {
    Template: FormTemplate,
    Description: FormDescription,
    Table: MantineSelectableTable,
    Pagination: Pagination,
  },
);

export const ItemDrawingInfoForm = () => {
  const {
    data: itemDrawingInfo,
    Fetcher: ItemDrawingInfoFormFetcher,
    itemCode,
    downLoadDocuments,
  } = useItemDrawingInfoFormFetch();
  const { currentPage, setPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
    setPage: state.setPage,
  }));

  const columns = () =>
    [
      {
        accessorFn: (row) => row.relatedCode ?? "-",
        id: "itemCode",
        header: COMMON_TEXT.COLUMN.ITEM_CODE,
      },
      {
        accessorFn: (row) => row.relatedName ?? "-",
        id: "itemName",
        header: COMMON_TEXT.COLUMN.ITEM_NAME,
      },
      {
        accessorFn: (row) => row.fileName ?? "-",
        id: "fileName",
        header: COMMON_TEXT.COLUMN.FILE_NAME,
      },
      {
        accessorFn: (row) => row.creatorUserName ?? "-",
        id: "creatorUserName",
        header: COMMON_TEXT.INSPECT.CREATOR,
      },
      {
        accessorFn: (row) =>
          row.updatedAt
            ? dayjs(row.updatedAt).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        id: "createdAt",
        header: COMMON_TEXT.COLUMN.CREATED_AT,
      },
      {
        accessorFn: (row) =>
          typeof row.fileSize === "number"
            ? `${row.fileSize.toLocaleString()} B`
            : "-",
        id: "fileSize",
        header: COMMON_TEXT.COLUMN.FILE_SIZE,
      },
      {
        header: COMMON_TEXT.COLUMN.ACTION,
        id: "action",
        Cell: ({ row }) => {
          const downloadKey = row.original.fileName;

          const downloadFile = () => {
            if (downloadKey) {
              void downLoadDocuments({
                keys: [downloadKey],
                type: "attachments_ITEM",
              });
            }
          };

          return downloadKey ? (
            <ActionIcon variant="outline" color="blue" onClick={downloadFile}>
              <IconDownload />
            </ActionIcon>
          ) : (
            "-"
          );
        },
      },
    ] as MRT_ColumnDef<CommonStandardAttachmentsGet200ResponseRowsInner>[];

  useEffect(() => {
    setPage(1);
  }, [itemCode, setPage]);

  return (
    <ItemDrawingInfoFormFetcher>
      <ItemDrawingInfo.Template isButtonDisabled={true}>
        <ItemDrawingInfo.Description>
          {COMMON_TEXT.DESCRIPTION.ITEM_DRAWING_INFO_DESC}
        </ItemDrawingInfo.Description>
        <ItemDrawingInfo.Table
          enableRowSelection={false}
          data={itemDrawingInfo?.rows ?? []}
          columns={columns()}
        />
        <Flex mt={"sm"} justify={"center"}>
          <ItemDrawingInfo.Pagination
            total={itemDrawingInfo?.totalPages ?? 0}
            value={currentPage}
            onChange={(page) => setPage(page)}
          />
        </Flex>
      </ItemDrawingInfo.Template>
    </ItemDrawingInfoFormFetcher>
  );
};
